import { useSelector, shallowEqual } from 'react-redux';

import { ActiveCall } from './widgets/active-call';

export const WidgetsController = () => {
  const widgets = useSelector((store) => store.widgets.activeWidgets, shallowEqual);

  /**
   * get widget by type
   * @param {*} type
   * @returns
   */
  const getWidgetByType = (type) => {
    switch (type) {
      case 'activeCall':
        return <ActiveCall key={'widget_' + type} />;
      default:
        throw new Error('Unknow widget type');
    }
  };

  const getWidgets = () => {
    return widgets.map((item) => {
      return getWidgetByType(item);
    });
  };

  const widgetsEl = getWidgets();

  return <>{widgetsEl}</>;
};
